import { useQuery } from '@tanstack/vue-query';
import { ref, Ref } from 'vue';

import financingFlow from '~/services/financing-flow-api/financing-flow';
import { queryKeys } from '~/store/queryClient';

export default function useFinancingDetails(id: Ref<string>) {
  const queryKey = ref(queryKeys.FINANCING.DETAILS(id.value));

  const queryFn = () => financingFlow.financings.getByProjectIdV2(id.value);

  const query = useQuery({
    queryFn,
    queryKey,
    refetchInterval: 30_000,
    staleTime: 30_000,
  });

  return query;
}

// eslint-disable-next-line perfectionist/sort-modules
export type UseFinancingDetailsData = Awaited<ReturnType<typeof useFinancingDetails>>['data']['value'];
